module.exports = __webpack_public_path__ + "img/b6-1.343220d.png";